import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_THIRD_PARTY_APPS,
    FETCH_THIRD_PARTY_APPS_FETCHING,
    FETCH_THIRD_PARTY_APPS_SUCCESS,
    FETCH_THIRD_PARTY_APPS_FAIL,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
    FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS,
    FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL,
    FETCH_THIRD_PARTY_APPS_AND_CAPABILITIES,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
    UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL
} from 'actions/ActionTypes';

// Workers
export function* fetchThirdPartyAppsSaga(action = {}) {
    try {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_FETCHING
        });

        const response = yield call(gcApi.get, '/partner-service/user-partner-connection');

        yield put({
            type: FETCH_THIRD_PARTY_APPS_SUCCESS,
            oauthTokens: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_FAIL
        });
    }
}

export function* fetchThirdPartyAppsPermissionsSaga(action = {}) {
    try {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING
        });

        const response = yield call(gcApi.get, '/partner-service/consumer/permissions');

        yield put({
            type: FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
            partnerPermissions: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL
        });
    }
}

export function* fetchThirdPartyAppsCapabilitiesSaga(action = {}) {
    const { consumerKey } = action;
    try {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING
        });

        const response = yield call(gcApi.get, `/consumer-service/consumer/capabilitiesForUser/${consumerKey}`);

        yield put({
            type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS,
            capabilities: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL
        });
    }
}

export function* fetchThirdPartyAppsAndCapabilitiesSaga(action = {}) {
    try {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_FETCHING
        });

        const appResponse = yield call(gcApi.get, '/partner-service/user-partner-connection');

        yield put({
            type: FETCH_THIRD_PARTY_APPS_SUCCESS,
            oauthTokens: appResponse.data
        });

        if (appResponse.data.length > 0) {
            try {
                yield put({
                    type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING
                });

                const responses = yield appResponse.data.map((thirdPartyToken) =>
                    call(gcApi.get, `/consumer-service/consumer/capabilitiesForUser/${thirdPartyToken.consumerKey}`)
                );

                yield responses.map((response) =>
                    put({
                        type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS,
                        capabilities: response.data
                    })
                );
            } catch (e) {
                yield put({
                    type: FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL
                });
            }
        }
    } catch (e) {
        yield put({
            type: FETCH_THIRD_PARTY_APPS_FAIL
        });
    }
}

export function* updateThirdPartyAppPermissionsSaga(action = {}) {
    try {
        yield put({
            type: UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING
        });

        if (action.appPermissions.permissions.length < 1) {
            yield call(gcApi.delete, `/partner-service/consumer/permissions/${action.appPermissions.consumerKey}`);
        } else {
            const permissions = {
                permissions: action.appPermissions.permissions
            };

            yield call(
                gcApi.put,
                `/partner-service/consumer/permissions/${action.appPermissions.consumerKey}`,
                permissions
            );
        }

        yield put({
            type: UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS,
            partnerPermissions: action.appPermissions
        });
    } catch (e) {
        yield put({
            type: UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL
        });
    }
}

// Watchers
export const thirdPartyAppsSagas = [
    takeEvery(FETCH_THIRD_PARTY_APPS, fetchThirdPartyAppsSaga),
    takeEvery(FETCH_THIRD_PARTY_APPS_PERMISSIONS, fetchThirdPartyAppsPermissionsSaga),
    takeEvery(FETCH_THIRD_PARTY_APPS_CAPABILITIES, fetchThirdPartyAppsCapabilitiesSaga),
    takeEvery(FETCH_THIRD_PARTY_APPS_AND_CAPABILITIES, fetchThirdPartyAppsAndCapabilitiesSaga),
    takeEvery(UPDATE_THIRD_PARTY_APPS_PERMISSIONS, updateThirdPartyAppPermissionsSaga)
];
